import React from 'react';
import { AoiInfoObject } from 'types';
import { Renew20 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';

interface LegendDescriptionProps {
  currentInfo: AoiInfoObject | null;
  previewInfo: AoiInfoObject | null;
}

const LegendDescription = ({
  currentInfo,
  previewInfo
}: LegendDescriptionProps) => {
  const currentEnquiryVol = getEnquiryVol(currentInfo);
  const previewEnquiryVol = getEnquiryVol(previewInfo);

  if (currentEnquiryVol === 'N/A' || previewEnquiryVol === 'N/A') {
    return null;
  }

  return (
    <div className="legend--desc">
      Based on historical data this change would{' '}
      {isIncrease(currentEnquiryVol, previewEnquiryVol)
        ? 'increase'
        : 'decrease'}{' '}
      your volumes by about {percentage(currentEnquiryVol, previewEnquiryVol)}%
    </div>
  );
};
const isIncrease = (before: number, after: number) => {
  return before <= after;
};

const percentage = (before: number, after: number) => {
  const total = before > 0 ? before : 1;
  const amount = 100 * Math.abs((before - after) / total);
  return Math.round(amount);
};

const getEnquiryVol = (info: AoiInfoObject | null) => {
  return info?.enquiryVolume ? Number(info?.enquiryVolume) : 'N/A';
};

const Legend: React.FC<Props> = ({
  previewAoi,
  currentInfo,
  previewInfo,
  isEditMode
}) => {
  return (
    <div className="legend-box enquiry">
      <div className="legend--title">Last 30 days&apos; enquiries</div>
      {previewInfo?.enquiryVolume && isEditMode && (
        <LegendDescription
          currentInfo={currentInfo}
          previewInfo={previewInfo}
        />
      )}
      <div className="legend--number">
        <div className="aoi-current-info">
          {getEnquiryVol(currentInfo)}
          {previewInfo?.enquiryVolume && isEditMode && <span>now</span>}
        </div>
        {isEditMode && (
          <div className="aoi-preview-info">
            {getEnquiryVol(previewInfo)}
            <span>projected</span>
            <Button
              renderIcon={Renew20}
              iconDescription="Refresh"
              tooltipPosition="top"
              hasIconOnly
              kind="ghost"
              onClick={() => previewAoi()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

type Props = {
  previewAoi: Function;
  currentInfo: AoiInfoObject | null;
  previewInfo: AoiInfoObject | null;
  isEditMode: boolean;
};

export default React.memo(Legend);
